import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Skeleton from "@mui/material/Skeleton";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import borders from "assets/theme/base/borders";

function ComplexStatisticsCard({
  color,
  title,
  count,
  percentage,
  icon,
  loading,
  done,
  text,
  textValue,
  onClick,
}) {
  return (
    // <Card>
    //   <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
    //     <MDBox
    //       variant="gradient"
    //       bgColor={color}
    //       color={color === "light" ? "dark" : "white"}
    //       coloredShadow={color}
    //       borderRadius="xl"
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       width="4rem"
    //       height="4rem"
    //       mt={-3}
    //     >
    //       <Icon fontSize="medium" color="inherit">
    //         {icon}
    //       </Icon>
    //     </MDBox>
    //     <MDBox textAlign="right" lineHeight={1.25}>
    //       <MDTypography variant="button" fontWeight="bold" color="text">
    //         {title}
    //       </MDTypography>
    //       <MDTypography variant="h4">{count}</MDTypography>
    //     </MDBox>
    //   </MDBox>
    //   <Divider />
    //   {/* <MDBox pb={2} px={2}>
    //     <MDTypography component="p" variant="button" color="text" display="flex">
    //       <MDTypography
    //         component="span"
    //         variant="button"
    //         fontWeight="bold"
    //         color={percentage.color}
    //       >
    //         {percentage.amount}
    //       </MDTypography>
    //       &nbsp;{percentage.label}
    //     </MDTypography>
    //   </MDBox> */}
    // </Card>
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2} onClick={onClick}>
        {/* ICON / SKELETON */}
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          {loading ? (
            <Skeleton variant="circular" width={32} height={32} />
          ) : (
            <Icon fontSize="medium" color="inherit">
              {icon}
            </Icon>
          )}
        </MDBox>

        {/* TEXT / SKELETON */}
        <MDBox textAlign="right" lineHeight={1.25} >
          {loading ? (
            <>
              <Skeleton variant="text" width={80} height={18} />
              <Skeleton variant="text" width={50} height={28} />
            </>
          ) : (
            <MDBox>
              <MDTypography
                variant="button"
                fontWeight="bold"
                color={title == "Missed" ? "primary" : "text"}
              >
                {title}
              </MDTypography>
              {/* <MDTypography variant="h5">
                {done !== undefined && done !== null ? done + " /" : ""} {count}
              </MDTypography> */}
              {/* <MDTypography variant="h5">
                <MDTypography component="span" variant="h5" color="success">
                  {done !== undefined && done !== null ? done + " / " : ""}
                </MDTypography>
                {count}
              </MDTypography> */}
              <MDTypography variant="h5" color={title == "Missed" ? "primary" : ""}>
                {done !== undefined && done !== null ? (
                  <>
                    <MDTypography component="span" variant="h5" color="success">
                      {done}
                    </MDTypography>
                    {" / "}
                  </>
                ) : null}
                {count}
              </MDTypography>
              {text && (
                <MDTypography variant="h5" color={title == "Missed" ? "primary" : ""}>
                  {textValue !== undefined && textValue !== null ? (
                    <>
                      <MDTypography
                        component="span"
                        variant="caption"
                        color="success"
                        fontWeight="bold"
                      >
                        {text} ₹ {textValue}
                      </MDTypography>
                    </>
                  ) : null}
                </MDTypography>
              )}
            </MDBox>
          )}
        </MDBox>
      </MDBox>

      <Divider />
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  loading: false,
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
  done: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ComplexStatisticsCard;
